<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col md="2">
          <v-subheader>نام</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field
            placeholder="نام"
            disabled
            v-model="firstName"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>نام خانوادگی</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field
            disabled
            placeholder="نام خانوادگی"
            v-model="lastName"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>ترتیب نمایش</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field
            disabled
            placeholder="کد ملی"
            v-model="nationalCode"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>آخرین ورود</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field
            disabled
            placeholder="آخرین ورود"
            v-model="lastLogin"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>تاریخ ثبت</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field
            disabled
            placeholder="تاریخ ثبت"
            v-model="registerDate"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>شهر</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field
            placeholder="شهر"
            disabled
            v-model="geoDivTitle"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>بیو</v-subheader>
        </v-col>
        <v-col md="8">
          <v-text-field v-model="bio" label="بیو" disabled chips></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" sm="12">
          <v-subheader>تصویر مدارک</v-subheader>
        </v-col>
        <v-col md="8" sm="12">
          <v-row>
            <v-col md="6" sm="12">
              <img :src="imgs[0]" alt="" height="200" />
            </v-col>
            <v-col md="6" sm="12" v-if="imgs[1]">
              <img :src="imgs[1]" alt=""
            /></v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">
            <v-icon color="amber darken-1" class="ml-2">info</v-icon>
            <p class="ma-0">وضعیت مورد نظر را انتخاب کنید</p>
            <div class="w-100 my-3">
              <v-combobox :items="items" v-model="select" chip dense reverse>
              </v-combobox>
            </div>
            <v-text-field placeholder="توضیح" v-model="descModal" v-if="select">
            </v-text-field>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#00932a"
              class="green lighten-4"
              outline
              text
              @click="editHandler"
              >تایید کردن</v-btn
            >
            <v-btn
              color="#b90000"
              class="red lighten-4 mr-2"
              text
              @click="dialog = false"
              >لغو کردن</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row
        ><v-col md="2">
          <v-subheader>وضعیت تایید</v-subheader>
        </v-col>
        <v-col md="8">
          <v-chip
            :color="
              isConfirm == 'تایید نشده' ? 'red darken-2' : 'green darken-2'
            "
            class="white--text"
            >{{ isConfirm }}</v-chip
          >
        </v-col>
      </v-row>
      <v-row justify="center mb-3">
        <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="dialog = true"
        >
          تغییر وضعیت
        </v-btn>
        <router-link to="/servieceprovider/documents">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
export default {
  created() {
    //Get By Id Product

    axios
      .get(`${baseURL}ServiceProvider/GetById?id=${this.$route.params.id}`)
      .then((res) => {
        this.object12 = res.data.data;
        this.firstName = res.data.data.firstName;
        this.lastName = res.data.data.lastName;
        this.username = res.data.data.username;
        this.nationalCode = res.data.data.nationalCode;
        this.lastLogin = res.data.data.lastLogin;
        this.registerDate = res.data.data.registerDate;
        this.geoDivisionId = res.data.data.geoDivisionId;
        this.geoDivTitle = res.data.data.geoDivTitle;
        this.bio = res.data.data.bio;
        this.isConfirm = res.data.data.isConfirm;
        //////console.log(res.data.data.upgradeLevelRequest.documents);
        res.data.data.upgradeLevelRequest.documents.map((item) => {
          //////console.log(item.document);
          this.imgs.push(item.document);
        });
      });
  },

  data() {
    return {
      id: this.$route.params.id,

      object12: null,
      firstName: "",
      lastName: "",
      descModal: "",
      username: "",
      nationalCode: "",
      lastLogin: "",
      registerDate: "",
      geoDivisionId: "",
      geoDivTitle: "",
      bio: "",
      isConfirm: "",
      image: null,
      list: [],
      selectItem: "null",
      priority: null,
      select: null,
      imgs: [],
      select1: [],
      items: [
        {
          value: 2,
          text: "تایید کردن",
        },
        {
          value: 3,
          text: "رد کردن",
        },
      ],
      items1: [],
      categoryList: [],
      productParentId: null,
      showInLanding: false,
      productFeatures: [],
      productBrands: [],
      productFeaturesItemList: [],
      firstItem: true,
      listBackup: null,
      productGroupId: null,
      weight: null,
      maxDayToCome: null,
      taxation: null,
      dialog: false,
      xxx: {
        featureId: null,
        subFeatureId: null,
        value: null,
        isMain: true,
        quantity: null,
        price: null,
        haveSecendFeature: null,
        secendFeatureId: null,
        secendSubFeatureId: null,
      },
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    onFileSelected(event) {
      this.image = event.target.files[0];
    },
    imageFile(value) {
      this.imageFile = value;
    },
    async editHandler() {
      //////console.log(123);
      await axios
        .put(
          `${baseURL}UpgradeLevelRequest/ChangeConfirmationStatus`,
          {
            id: this.object12.upgradeLevelRequest.id,
            status: this.select.value,
            description: this.descModal,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.dialog = false;
          this.isConfirm == "تایید نشده"
            ? (this.isConfirm = "تایید شده")
            : (this.isConfirm = "تایید نشده");
        })
        .catch(() => {
          this.productFeaturesItemList.shift();
        });
    },
    treeHandler(e) {
      this.productParentId = e;
    },
    productCategory(e) {
      this.productCategoryId = e;
    },
    treeFeatures(e) {
      this.productFeatures = e;
    },
    treeBrands(e) {
      this.productBrands = e;
    },
    productFeaturesItemHandler(e) {
      this.productFeaturesItemList.push(e);
    },
    removeIndexHandler(e) {
      const list = this.productFeaturesItemList;
      this.productFeaturesItemList = [];
      list.map((item, index) => {
        if (index != e) {
          this.productFeaturesItemList.push(item);
        }
      });
      return this.productFeaturesItemList;
    },
  },
};
</script>

<style lang="scss">
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}

.row {
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
</style>